import React from "react";
import { useNavigate } from "react-router-dom";

export default function UserCard({ user }) {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/user/${user.id}`);
  };
  return (
    <div className="card user-card" onClick={handleCardClick}>
      <div className="card-body">
        <img
          className="user-card-image"
          src={user.image}
          alt={`${user.firstName} ${user.lastName} img`}
        />

        <p className="mt-2 fw-bold">
          {user.firstName} {user.lastName}
        </p>
        <p>
          <svg
            className="me-2"
            fill="#cdc8b5"
            height="1rem"
            width="1rem"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 493.497 493.497"
            stroke="#cdc8b5"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path d="M444.556,85.218H48.942C21.954,85.218,0,107.171,0,134.16v225.177c0,26.988,21.954,48.942,48.942,48.942h395.613 c26.988,0,48.941-21.954,48.941-48.942V134.16C493.497,107.171,471.544,85.218,444.556,85.218z M460.87,134.16v225.177 c0,2.574-0.725,4.924-1.793,7.09L343.74,251.081l117.097-117.097C460.837,134.049,460.87,134.096,460.87,134.16z M32.628,359.336 V134.16c0-0.064,0.033-0.11,0.033-0.175l117.097,117.097L34.413,366.426C33.353,364.26,32.628,361.911,32.628,359.336z M251.784,296.902c-2.692,2.691-7.378,2.691-10.07,0L62.667,117.846h368.172L251.784,296.902z M172.827,274.152l45.818,45.819 c7.512,7.511,17.493,11.645,28.104,11.645c10.61,0,20.592-4.134,28.104-11.645l45.82-45.819l101.49,101.499H71.327L172.827,274.152z "></path>{" "}
            </g>
          </svg>
          {user.email}
        </p>
        <p>
          <svg
            className="me-1"
            fill="#cdc8b5"
            height="1rem"
            width="1rem"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 297 297"
            stroke="#cdc8b5"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <g>
                {" "}
                <path d="M148.5,0C87.43,0,37.747,49.703,37.747,110.797c0,91.026,99.729,179.905,103.976,183.645 c1.936,1.705,4.356,2.559,6.777,2.559c2.421,0,4.841-0.853,6.778-2.559c4.245-3.739,103.975-92.618,103.975-183.645 C259.253,49.703,209.57,0,148.5,0z M148.5,272.689c-22.049-21.366-90.243-93.029-90.243-161.892 c0-49.784,40.483-90.287,90.243-90.287s90.243,40.503,90.243,90.287C238.743,179.659,170.549,251.322,148.5,272.689z"></path>{" "}
                <path d="M148.5,59.183c-28.273,0-51.274,23.154-51.274,51.614c0,28.461,23.001,51.614,51.274,51.614 c28.273,0,51.274-23.153,51.274-51.614C199.774,82.337,176.773,59.183,148.5,59.183z M148.5,141.901 c-16.964,0-30.765-13.953-30.765-31.104c0-17.15,13.801-31.104,30.765-31.104c16.964,0,30.765,13.953,30.765,31.104 C179.265,127.948,165.464,141.901,148.5,141.901z"></path>{" "}
              </g>{" "}
            </g>
          </svg>
          {user.address.address}, {user.address.city}
        </p>
        <p className="user-card-designation">
          <svg
            fill="#cdc8b5"
            height="1.1rem"
            width="1.1rem"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            className="me-2"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <g>
                {" "}
                <g>
                  {" "}
                  <path d="M242.288,344.571l-12.722,82.262c-2.134,13.797,7.322,26.714,21.12,28.847c13.799,2.132,26.713-7.326,28.847-21.12 l13.916-89.988H242.288z"></path>{" "}
                </g>{" "}
              </g>{" "}
              <g>
                {" "}
                <g>
                  {" "}
                  <path d="M177.857,426.833l-12.722-82.262h-51.162l13.916,89.988c2.133,13.796,15.045,23.252,28.847,21.12 C170.534,453.546,179.99,440.631,177.857,426.833z"></path>{" "}
                </g>{" "}
              </g>{" "}
              <g>
                {" "}
                <g>
                  {" "}
                  <path d="M205.095,0c-24.164,0-43.662,19.582-43.662,43.662c0,24.087,19.521,43.662,43.662,43.662 c24.093,0,43.662-19.518,43.662-43.662C248.758,19.503,229.176,0,205.095,0z"></path>{" "}
                </g>{" "}
              </g>{" "}
              <g>
                {" "}
                <g>
                  {" "}
                  <path d="M474.322,286.458c0-5.095-4.13-9.225-9.225-9.225h-66.329c1.215-1.929,1.929-4.206,1.929-6.654 c0-6.906-5.606-12.515-12.515-12.515h-29.039c0-10.804,0-19.068,0-29.941h56.811c5.743,0,10.398-4.655,10.398-10.397v-91.356 c0-5.743-4.655-10.397-10.398-10.397H261.546c-5.743,0-10.397,4.655-10.397,10.397v91.356c0,5.743,4.655,10.397,10.397,10.397 h56.811c0,10.878,0,19.134,0,29.941h-29.039c-6.89,0-12.515,5.591-12.515,12.515c0,2.448,0.714,4.725,1.929,6.654H46.903 c-5.095,0-9.225,4.13-9.225,9.225v33.35c0,5.095,4.13,9.225,9.225,9.225h14.454c0,6.513,0,156.787,0,164.195 c0,10.368,8.404,18.772,18.772,18.772S98.9,503.596,98.9,493.228c0-7.415,0-157.686,0-164.195h314.113 c0,6.513,0,156.787,0,164.195c0,10.368,8.404,18.772,18.772,18.772s18.772-8.404,18.772-18.772c0-7.415,0-157.686,0-164.195h14.54 c5.095,0,9.225-4.13,9.225-9.225L474.322,286.458L474.322,286.458z M338.75,189.255c-9.503,0-17.207-7.704-17.207-17.207 c-0.001-9.502,7.703-17.207,17.207-17.207c9.503,0,17.207,7.704,17.207,17.207S348.254,189.255,338.75,189.255z"></path>{" "}
                </g>{" "}
              </g>{" "}
              <g>
                {" "}
                <g>
                  {" "}
                  <path d="M236.13,217.728c0-9.19,0-79.936,0-91.356c0-12.79,9.506-23.374,21.818-25.13c-11.694,0-94.092,0-107.351,0 c-18.294,0-35.282,10.627-43.281,27.074c-11.684,24.035-24.892,54.041-30.546,68.158c-4.219,10.542,0.675,22.53,11.066,27.107 l73.739,32.482c10.644,4.69,23.082-0.139,27.772-10.787c4.69-10.647-0.14-23.082-10.787-27.772l-54.749-24.116 c6.208-14.264,14.123-31.686,21.398-46.649c0.349-0.715-0.006-1.1,0.771-0.932c0.777,0.169,1.34,0.847,1.361,1.643l2.188,39.729 l35.5,15.637c18.76,8.263,27.269,30.17,19.006,48.93c-1.651,3.747-3.859,7.07-6.466,9.947h63.548V243.12 C247.302,242.889,236.13,231.597,236.13,217.728z"></path>{" "}
                </g>{" "}
              </g>{" "}
            </g>
          </svg>
          {user.company.title}
        </p>
        <p>
          <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 122.88 122.76"
            fill="#cdc8b5"
            height="1rem"
            width="1rem"
            className="me-2"
          >
            <title>corporate</title>
            <path d="M26.32,110.82V46.48H3.57v66H25a8,8,0,0,0-1.22,3.29l-.06.28H1.79A1.79,1.79,0,0,1,0,114.28V45.52a2.68,2.68,0,0,1,.77-1.86,2.63,2.63,0,0,1,1.86-.77H26.32V3.14A3.1,3.1,0,0,1,27.24.93h0A3.12,3.12,0,0,1,29.46,0H93.14a3.12,3.12,0,0,1,2.22.92l.14.15a3.09,3.09,0,0,1,.79,2.07V42.89h24a2.62,2.62,0,0,1,1.85.77h0a2.64,2.64,0,0,1,.77,1.85v68.76a1.79,1.79,0,0,1-1.79,1.79H99.16l-.06-.28a7.93,7.93,0,0,0-1.22-3.29h21.43v-66h-23v64c-.25-.32-.53-.67-.83-1.07h0a13.93,13.93,0,0,0-2.18-2.28l-.54-.43V3.57H29.89V106.91l-.26.21a13.12,13.12,0,0,0-2.19,2.28c-.43.56-.8,1-1.12,1.42Zm47.8-5.13a43,43,0,0,0,10.17,5.09c7.32,2.47,7.29,1.55,7.29,12H67.16l7-17.07Zm-25.84,0a43.22,43.22,0,0,1-10.17,5.09c-7.32,2.47-7.3,1.55-7.3,12H55.24l-7-17.07Zm5-4.57c.18-1.45-4.09-6.92-4.87-9.58-1.68-2.66-2.27-6.91-.44-9.69.72-1.12.41-2.09.41-3.63,0-15.28,26.78-15.29,26.78,0,0,1.94-.43,2.39.61,3.92,1.75,2.53.85,7-.63,9.41-1,2.77-5.43,8-5.1,9.57.28,7.84-16.78,7.58-16.73,0Zm9.77,13.56H64a1.53,1.53,0,0,0,1.54-1.53v-2.5A1.54,1.54,0,0,0,64,109.11H58.45a1.53,1.53,0,0,0-1.53,1.54v2.49a1.53,1.53,0,0,0,1.53,1.54h1l-1.83,8.08h7.27l-1.76-8.08Zm40.18-34h7.42c.16,0,.3.1.3.21v5.83c0,.12-.14.23-.3.23h-7.42c-.16,0-.3-.1-.3-.23V80.88c0-.11.14-.21.3-.21ZM12,80.67h7.42c.16,0,.3.1.3.21v5.83c0,.12-.14.23-.3.23H12c-.16,0-.3-.1-.3-.23V80.88c0-.11.14-.21.3-.21ZM37.9,10.5H84.71a1.43,1.43,0,0,1,1.42,1.43V32.79a1.43,1.43,0,0,1-1.42,1.43H37.9a1.43,1.43,0,0,1-1.42-1.43V11.93A1.41,1.41,0,0,1,37.9,10.5Zm65.37,57.44h7.42c.16,0,.3.1.3.22V74c0,.11-.14.22-.3.22h-7.42c-.16,0-.3-.1-.3-.22V68.16c0-.14.14-.22.3-.22Zm0-12.75h7.42c.16,0,.3.1.3.22v5.83c0,.11-.14.22-.3.22h-7.42c-.16,0-.3-.1-.3-.22V55.41c0-.12.14-.22.3-.22ZM12,67.94h7.42c.16,0,.3.1.3.22V74c0,.11-.14.22-.3.22H12c-.16,0-.3-.1-.3-.22V68.16c0-.14.14-.22.3-.22Zm0-12.75h7.42c.16,0,.3.1.3.22v5.83c0,.11-.14.22-.3.22H12c-.16,0-.3-.1-.3-.22V55.41c0-.12.14-.22.3-.22ZM75.39,63h9.27a.3.3,0,0,1,.29.3V73.85a.29.29,0,0,1-.29.29H80.92a18.14,18.14,0,0,0-1.24-5.23,15.14,15.14,0,0,0-2.88-4.57h0A17.87,17.87,0,0,0,75.39,63ZM37.94,63H48.45a17.16,17.16,0,0,0-2.25,2.34,14.85,14.85,0,0,0-2.65,5.19h0c-.13.47-.24.92-.32,1.36s-.14.87-.19,1.34l0,.27,0,.61H37.94a.3.3,0,0,1-.3-.29V63.32a.31.31,0,0,1,.3-.3ZM74.13,42.58H84.66a.3.3,0,0,1,.29.3V53.41a.3.3,0,0,1-.29.3H74.13a.31.31,0,0,1-.3-.3V42.88a.31.31,0,0,1,.3-.3Zm-18.1,0H66.56a.31.31,0,0,1,.3.3V53.41a.31.31,0,0,1-.3.3H56a.3.3,0,0,1-.29-.3V42.88a.3.3,0,0,1,.29-.3Zm-18.09,0H48.47a.31.31,0,0,1,.3.3V53.41a.31.31,0,0,1-.3.3H37.94a.31.31,0,0,1-.3-.3V42.88a.31.31,0,0,1,.3-.3Z" />
          </svg>
          {user.company.name}
        </p>
      </div>
    </div>
  );
}
